import AdminWorkers from './AdminWorkers';

export default AdminWorkers;
